import Vue from 'vue';
import Vuex from 'vuex';

import Notifications from 'vue-notification';
// https://github.com/euvl/vue-notification
Vue.use(Notifications);
Vue.use(Vuex);

const vue = new Vue();

const eventmap = [];

// Stau
eventmap.STATIONARY_TRAFFIC = 'stau';
eventmap.QUEUING_TRAFFIC = 'stau';
eventmap.SLOW_TRAFFIC = 'stau';
eventmap.HEAVY_TRAFFIC = 'stau';
eventmap.UNSPECIFIED_ABNORMAL_TRAFFIC = 'gefahr';
eventmap.OTHER = 'gefahr';

// Sperrung
eventmap.ROAD_CLOSED = 'vollsperrung';
eventmap.CAR_POOL_LANE_IN_OPERATION = 'vollsperrung';
eventmap.CARRIAGEWAY_CLOSURES = 'vollsperrung';
eventmap.CLEAR_A_LANE_FOR_EMERGENCY_VEHICLES = 'vollsperrung';
eventmap.CLEAR_A_LANE_FOR_SNOWPLOUGHS_AND_GRITTING_VEHICLES = 'vollsperrung';
eventmap.CLOSED_PERMANENTLY_FOR_THE_WINTER = 'vollsperrung';
eventmap.CONTRAFLOW = 'vollsperrung';
eventmap.DO_NOT_USE_SPECIFIED_LANES_OR_CARRIAGEWAYS = 'vollsperrung';
eventmap.HARD_SHOULDER_RUNNING_IN_OPERATION = 'vollsperrung';
eventmap.HEIGHT_RESTRICTION_IN_OPERATION = 'vollsperrung';
eventmap.INTERMITTENT_SHORT_TERM_CLOSURES = 'vollsperrung';
eventmap.KEEP_TO_THE_LEFT = 'vollsperrung';
eventmap.KEEP_TO_THE_RIGHT = 'vollsperrung';
eventmap.LANE_CLOSURES = 'vollsperrung';
eventmap.LANES_DEVIATED = 'vollsperrung';
eventmap.NARROW_LANES = 'vollsperrung';
eventmap.NEW_ROADWORKS_LAYOUT = 'vollsperrung';
eventmap.OVERNIGHT_CLOSURES = 'vollsperrung';
eventmap.ROAD_CLEARED = 'vollsperrung';
eventmap.ROLLING_ROAD_BLOCK = 'vollsperrung';
eventmap.RUSH_HOUR_LANE_IN_OPERATION = 'vollsperrung';
eventmap.SINGLE_ALTERNATE_LINE_TRAFFIC = 'vollsperrung';
eventmap.TIDAL_FLOW_LANE_IN_OPERATION = 'vollsperrung';
eventmap.TURN_AROUND_IN_OPERATION = 'vollsperrung';
eventmap.USE_OF_SPECIFIED_LANES_OR_CARRIAGEWAYS_ALLOWED = 'vollsperrung';
eventmap.USE_SPECIFIED_LANES_OR_CARRIAGEWAYS = 'vollsperrung';
eventmap.VEHICLE_STORAGE_IN_OPERATION = 'vollsperrung';
eventmap.WEIGHT_RESTRICTION_IN_OPERATION = 'vollsperrung';
eventmap.OTHER = 'gefahr';

function isMobile() {
  const agent = navigator.userAgent;
  const isWebkit = agent.indexOf('AppleWebKit') > 0;
  const isIOS = agent.indexOf('iPhone') > 0 || agent.indexOf('iPod') > 0;
  const isAndroid = agent.indexOf('Android') > 0;
  const isNewBlackBerry = agent.indexOf('AppleWebKit') > 0 && agent.indexOf('BlackBerry') > 0;
  const isWebOS = agent.indexOf('webOS') > 0;
  const isWindowsMobile = agent.indexOf('IEMobile') > 0;
  const isSmallScreen = screen.width < 767 || (isAndroid && screen.width < 1000);
  const isUnknownMobile = isWebkit && isSmallScreen;
  const isMobile = isIOS || isAndroid || isNewBlackBerry || isWebOS || isWindowsMobile || isUnknownMobile;

  return isMobile && isSmallScreen && document.cookie.indexOf('mobileFullSiteClicked=') < 0;
}

function isPushPossible(state) {
  return (
    state.isMobile &&
    'serviceWorker' in navigator &&
    'PushManager' in window &&
    window.navigator.userAgent.indexOf('Edge') === -1 && // Desktop
    window.navigator.userAgent.indexOf('EdgA') === -1
  ); // Mobile
}

function getLaneSymbol(letter) {
  if (letter == "u") {
    return "ARROW_DOWN"
  }
  if (letter == "i") {
    return "ARROW_DOWN"
  }
  if (letter == "1") {
    return "SEPARATE"
  }
  if (letter == "2") {
    return "SEPARATE"
  }
  if (letter == "o") {
    return "ARROW_UP"
  }
  if (letter == "e") {
    return "ARROW_UP"
  }
  if (letter == "x") {
    return "CLOSED"
  }
  if (letter == "r") {
    return "BORDER_RIGHT"
  }
  if (letter == "l") {
    return "BORDER_LEFT"
  }
  if (letter == "s") {
    return "BREAKDOWN_LANE"
  }
}

function verkehrsfuehrung(laneStatusCode) {
  let vf = '<div class=\'impact-list\'>';

  if (laneStatusCode) {
    let statusInfo = [];
    for (let i = 0; i < laneStatusCode.length; i++) {
      statusInfo.push(getLaneSymbol(laneStatusCode[i]))
    }

    statusInfo.forEach((element) => {
      vf += '<div class=\'impact-symbol\'>';
      if (element == 'SEPARATE') {
        vf += '<img ' + 'src=' + 'img/impact/SEPARATE.png' + '>';
      } else if (element == 'CLOSED') {
        vf += '<img ' + 'src=' + './img/impact/CLOSED.png' + '>';
      } else if (element == 'ARROW_UP') {
        vf += '<img ' + 'src=' + './img/impact/ARROW_UP.png' + '>';
      } else if (element == 'ARROW_DOWN') {
        vf += '<img ' + 'src=' + './img/impact/ARROW_DOWN.png' + '>';
      } else if (element == 'BORDER_RIGHT') {
        vf += '<img ' + 'src=' + './img/impact/BORDER_RIGHT.png' + '>';
      } else if (element == 'BREAKDOWN_LANE') {
        vf += '<img ' + 'src=' + './img/impact/BREAKDOWN_LANE.png' + '>';
      } else if (element == 'BORDER_LEFT') {
        vf += '<img ' + 'src=' + './img/impact/BORDER_LEFT.png' + '>';
      }
      vf += '</div>';
    });
  }
  vf += '</div>';
  return vf;
}


export default new Vuex.Store({
  state: {
    width: 0,
    // URL: process.env.NODE_ENV === 'production' ? './' : 'https://verkehrsservice2.traffgoroad.com/',
    URL: process.env.NODE_ENV === 'production' ? './' : 'https://verkehrsservice.hessen.de/',
    checkServerDataInterval: null,
    newstickerMeldungen: [],
    pushNotifierSubscribed: false,
    firstVisit: !localStorage.getItem('firstVisit'),
    reloadLayer: false,
    isLoading: false,
    isMobile: isMobile(),
    userToken: null,
    userPin: null,
    dataTimestamp: null,
    applicationServerPublicKey:
      'BGlk8dcgfA1OmERqcwwyRwXi6xlDbn29HN4WKEZWOHX0mRPycHGc1yPYM-beuQW07c_-n4tlRVT0PDuQSJdfYyI',
    jumpTo: [],
    device: null,
    smallSidebarActive: true,
    sidebarActive: null,
    ExtendedSidebarActive: false,
    ExtendedSidebarActiveLayer: null,
    activeListenansichtOption: 'Tagesbaustellen',
    activeProfilOption: null,
    streetObjListenansicht: {},
    kartenmode: null,
    routeLayer: null,
    layers: [
      {
        id: 0,
        name: 'Verkehrsmeldungen',
        active: true,
        sidebarIcon: {
          img_on: 'stau_on',
          img_off: 'stau_off',
          type: 'svg',
        },
        listenansicht: {
          name: 'Verkehrsmeldungen',
          streets: [],
        },
        // http://vzhv2.traffgoroad.com
        wms: {
          src: 'cgi-bin/mapserv?map=map/asda.map&',
          layerName: 'divaline',
          format: 'image/png',
        },
        icons: {
          src: 'syncdata/poidiva.json',
          data: null,
          reload: true,
          markerCluster: { name: 'stau_cluster', colorClass: 'colorRed' }, // 'redMarkerCluster',
          title: (props) => {
            return props.title;
          },
          popup: (obj) => {
            const props = obj.props;
            const streettype = obj.streettype;
            const html = `
            ${props.street
                ? `<div class="${streettype} maxWidth50 textcenter widthFit fontweight600 marginbottom15" style="padding:1.5px 10px">
              ${props.street}
            </div>`
                : ''
              }
            ${props.sperrung ? `<h3>Sperrung</h3>` : ''}
            <div class="marginbottom15">${props.von} →</br> ${props.bis}</div>
            ${props.staulaenge
                ? `<div class="fontweight600 widthFit marginbottom15">
                  ${props.staulaenge} km ${props.type === 'STATIONARY_TRAFFIC' ? 'Stau' : 'zähfließender Verkehr'}
                </div>`
                : ''
              }
            ${props.reisezeitverlust
                ? `<div class="displayflex flexbetween">
              <div class="backgroundYellow borderRadius30 fontweight600 widthFit marginbottom15" style="padding:1.5px 10px;">
                + ${props.reisezeitverlust} Min 
              </div>
            </div>`
                : ''
              }
            <small>Stand: ${props.stand}</small>
            `;
            return html;
          },
          iconUrl: (props, ohneZapfen) => {
            let data = eventmap[props.type]
              ? require(`../public/img/vue_svg/${eventmap[props.type]}.svg`)
              : require(`../public/img/vue_svg/gefahr.svg`);
            if (props.reisezeitverlust && !ohneZapfen) {
              data += `
              <div 
                style="height:18px;position:absolute;top: -9px;right:0;padding: 0 10px;background-color: #EFD53C; white-space:nowrap;transform: translate(75%,0); box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px;" 
                class="textcenter backgroundWhite fontweight600 borderRadius30"
              >
                + ${props.reisezeitverlust} min.
              </div>
              `;
            }
            return { data, type: 'svg' };
          },
        },
      },
      {
        id: 1,
        name: 'Tagesbaustellen',
        active: true,
        listenansicht: {
          name: 'Tagesbaustellen',
          streets: [],
        },
        sidebarIcon: {
          img_on: 'tagesbaustelle_geortet_on',
          img_off: 'tagesbaustelle_geortet_off',
          type: 'svg',
        },
        icons: {
          src: 'syncdata/poidora.json',
          data: null,
          reload: true,
          markerCluster: { name: 'tagesbaustellen_cluster', colorClass: 'colorRed' },
          title: (props) => props.title,
          popup: (obj) => {
            const props = obj.props;
            const streettype = obj.streettype;
            const html = `
            ${props.street
                ? `<div class="${streettype} textcenter widthFit fontweight600 marginbottom15" style="padding:1.5px 10px">
              ${props.street}
            </div>`
                : ''
              }
            <div class="marginbottom15">${props.strassennummern}</div>
            <div class="marginbottom15 fontweight600">${props.title} ${props.kommentar ? props.kommentar : ''}</div>
            `;
            return html;
          },
          iconUrl: () => {
            return {
              data: require(`../public/img/vue_svg/tagesbaustelle_geortet_on.svg`),
              type: 'svg',
            };
          },
        },
      },
      {
        id: 2,
        name: 'Dauerbaustellen',
        active: true,
        listenansicht: {
          name: 'Dauerbaustellen',
          streets: [],
        },
        sidebarIcon: {
          img_on: 'dauerbaustellen_on',
          img_off: 'dauerbaustellen_off',
          type: 'svg',
        },
        wms: {
          src: 'cgi-bin/mapserv?map=map/roadworks.map&',
          layerName: 'roadworksline',
          format: 'image/png',
        },
        icons: {
          src: 'syncdata/poiroadworks.json',
          data: null,
          reload: true,
          markerCluster: { name: 'dauerbaustelle_cluster', colorClass: 'colorDarkGrey' }, // 'greyMarkerCluster',
          title: (props) => props.title,
          popup: (obj) => {
            console.log(obj)
            const props = obj.props;
            const streettype = obj.streettype;
            let quelle = "";
            if (props.name && props.name.includes("MIA")) {
              quelle = "Autobahn GmbH";
            } else {
              quelle = "Hessen mobil"
            }

            let verkehrfuehrunggrafik = "";
            if (props.laneStatusCoded) {
              verkehrfuehrunggrafik = verkehrsfuehrung(props.laneStatusCoded);
            }
            const html = `
            ${props.street
                ? `<div class="${streettype} maxWidth50 textcenter widthFit fontweight600 marginbottom15" style="padding:1.5px 10px">
              ${props.street}
            </div>`
                : ''
              }
            <div class="marginbottom15 fontweight600">${props.kommentar}</div>

            
            <div class="marginbottom15">
                ${props.ortauskommentar
                ? props.ortauskommentar
                : (props.von && props.bis && props.von === props.bis)
                  ? props.von
                  : (props.von && props.bis)
                    ? `Von ${props.von} bis ${props.bis}`
                    : ''}
            </div>

            
            ${props.startzeit
                ? `<div class="marginbottom15">
                Aktuelle Bauphase:<br>
                Vom ${props.startzeit} bis ${props.endzeit}
                </div>` : ''
              } 

            ${props.sperrungsart
                ? `
            <div class="displayflex fontweight600 marginbottom15">
              <div class="selfAlignCenter">
                ${props.sperrungsart}
                ${props.sperrungsbeginn && props.sperrungsende
                  ? `</br>Vom ${props.sperrungsbeginn} bis ${props.sperrungsende}`
                  : !props.sperrungsbeginn && props.sperrungsende
                    ? `</br>Bis ${props.sperrungsende}`
                    : props.sperrrungsbeginn && !props.sperrungsende
                      ? `</br>Vom ${props.sperrungsbeginn}`
                      : ''
                }
              </div >
            </div >
               `
                : ''
              }

            ${props.laneStatusCoded ? `
                <div class="displayflex fontweight600 marginbottom15">
                ${verkehrfuehrunggrafik}
                </div>
              ` : ''

              }
            
            ${props.umleitungsempfehlung ? `<div><b>Aktuelle Umleitung</b><br>${props.umleitungsempfehlung}<br><br> </div>` : ''}


            ${props.startzeitgesamt
                ? `<div class="marginbottom15">
                Gesamtdauer der Baumaßnahme:<br>
                Vom ${props.startzeitgesamt} bis ${props.endzeitgesamt}
                </div>` : ''
              }  

            <small>Stand: ${props.stand} (${quelle})</small>
            `;
            return html;
          },
          iconUrl: (props) => {
            return {
              data: require(`../public/img/vue_svg/dauerbaustellen_on.svg`),
              type: 'svg',
            };
          },
        },
      },
      {
        id: 3,
        name: 'Zukünftige Dauerbaustellen',
        active: false,
        listenansicht: {
          name: 'Zukünftige Baustellen',
          streets: [],
        },
        sidebarIcon: {
          img_on: 'geplante_baustelle_on',
          img_off: 'geplante_baustelle_off',
          type: 'svg',
        },
        wms: {
          src: 'cgi-bin/mapserv?map=map/roadworks.map&',
          layerName: 'roadworksplannedline',
          format: 'image/png',
        },
        icons: {
          src: 'syncdata/poiroadworksplanned.json',
          data: null,
          reload: true,
          markerCluster: { name: 'geplante_baustellen_cluster', colorClass: 'colorDarkGrey' }, // 'greyMarkerCluster',
          title: (props) => `ab ${props.starttime.split(' ')[0]}`,
          popup: (obj) => {
            const props = obj.props;
            const streettype = obj.streettype;
            let quelle = "";
            if (props.name && props.name.includes("MIA")) {
              quelle = "Autobahn GmbH";
            } else {
              quelle = "Hessen mobil"
            }

            let verkehrfuehrunggrafik = "";
            if (props.laneStatusCoded) {
              verkehrfuehrunggrafik = verkehrsfuehrung(props.laneStatusCoded);
            }
            const html = `
            ${props.street
                ? `<div class="${streettype} maxWidth50 textcenter widthFit fontweight600 marginbottom15" style="padding:1.5px 10px">
              ${props.street}
            </div>`
                : ''
              }
            <div class="marginbottom15 fontweight600">${props.kommentar}</div>

            
            <div class="marginbottom15">
                ${props.ortauskommentar
                ? props.ortauskommentar
                : (props.von && props.bis && props.von === props.bis)
                  ? props.von
                  : (props.von && props.bis)
                    ? `Von ${props.von} bis ${props.bis}`
                    : ''}
            </div>
            
            ${props.startzeit
                ? `<div class="marginbottom15">
                Aktuelle Bauphase:<br>
                Vom ${props.startzeit} bis ${props.endzeit}
                </div>` : ''
              } 

            
            ${props.sperrungsart
                ? `
            <div class="displayflex fontweight600 marginbottom15">
              <div class="selfAlignCenter">
                ${props.sperrungsart}
                ${props.sperrungsbeginn && props.sperrungsende
                  ? `</br>Von ${props.sperrungsbeginn} bis ${props.sperrungsende}`
                  : !props.sperrungsbeginn && props.sperrungsende
                    ? `</br>Bis ${props.sperrungsende}`
                    : props.sperrrungsbeginn && !props.sperrungsende
                      ? `</br>Von ${props.sperrungsbeginn}`
                      : ''
                }
              </div >
            </div >
               `
                : ''
              }

            ${props.laneStatusCoded ? `
                <div class="displayflex fontweight600 marginbottom15">
                ${verkehrfuehrunggrafik}
                </div>
              ` : ''

              }
            
            ${props.umleitungsempfehlung ? `<div><b>Aktuelle Umleitung</b><br>${props.umleitungsempfehlung}<br><br> </div>` : ''}

            ${props.startzeitgesamt
                ? `<div class="marginbottom15">
                Gesamtdauer der Baumaßnahme:<br>
                Vom ${props.startzeitgesamt} bis ${props.endzeitgesamt}
                </div>` : ''
              }                

            <small>Stand: ${props.stand} (${quelle})</small>
            `;
            return html;

          },
          iconUrl: (props) => {
            return {
              data: require(`../public/img/vue_svg/geplante_baustelle_on.svg`),
              type: 'svg',
            };
          },
        },
      },
      // {
      //   id: 4,
      //   name: 'Verkehrskameras',
      //   active: false,
      //   listenansicht: {
      //     name: 'Verkehrskameras',
      //     streets: []
      //   },
      //   sidebarIcon: {
      //     img_on: 'webcam_on',
      //     img_off: 'webcam_off',
      //     type: 'svg'
      //   },
      //   icons: {
      //     src: 'syncdata/camticker.json',
      //     data: null,
      //     reload: true,
      //     markerCluster: { name: 'kamera_cluster', colorClass: 'colorDarkGrey' }, // 'greyMarkerCluster',
      //     title: (props) => { return props.title; },
      //     popup: (obj) => {
      //       const props = obj.props;
      //       const streettype = obj.streettype;
      //       const target = obj.target;
      //       const header = `
      //                     <div class="displayflex marginbottom15">
      //                       ${target === 'Listenansicht' ? '' : `${props.filetyp === 'bild' ? '<img class="svgIcon marginleft5" src="img/vue_svg/kamera_standbild.svg" />' : '<img class="svgIcon marginleft5" src="img/vue_svg/webcam.svg" />'}`}
      //                       <div
      //                         class="${streettype} ${target === 'Listenansicht' ? '' : 'marginleft15'} maxWidth50 textcenter marginright15 fontweight600 selfAlignCenter"
      //                         style="padding: 1.5px 10px;"
      //                       >
      //                           ${props.street}
      //                       </div>
      //                       <div class="selfAlignCenter">${props.title}</div>
      //                     </div>
      //                       `;
      //       let description;
      //       if (props.filetyp === 'bild') {
      //         const url = `syncdata/kamera/${props.id}.jpg`;
      //         description = `<p><img width='240px' height='160px' style='cursor:pointer;' src='${url}' alt='kamera' onclick="document.getElementById('webcamPicture').src = '${url}'; document.getElementById('modalWebcam').style.display='block'; event.stopPropagation(); "/></p>`;
      //       } else if (props.filetyp === 'video') {
      //         const url = `syncdata/video/${props.id}.mp4`;
      //         description = `<p><video width='234px' height='192px' poster='${require('@/assets/images/video-black.png')}' preload='none' controls><source src='${url}' type='video/mp4'> Your browser does not support the video tag.</video></p>`;
      //       }
      //       return header + description;
      //     },
      //     iconUrl: (props) => {
      //       const data = props.filetyp === 'bild'
      //         ? require(`../public/img/vue_svg/kamera_standbild.svg`)
      //         : require(`../public/img/vue_svg/webcam_on.svg`);
      //       return { data, type: 'svg' };
      //     }
      //   }
      // },
      // {
      //   id: 9,
      //   name: 'Netzbeeinflussung',
      //   active: false,
      //   listenansicht: {
      //     name: 'Netzbeeinflussung',
      //     streets: []
      //   },
      //   sidebarIcon: {
      //     img_on: 'dwista',
      //     img_off: 'dwista_off',
      //     type: 'svg'
      //   },
      //   icons: {
      //     src: 'syncdata/dwista.json',
      //     data: null,
      //     reload: true,
      //     markerCluster: {
      //       name: 'dwista_cluster',
      //       colorClass: 'colorDarkGrey'
      //     },
      //     popupOptions: { maxWidth: 300 },
      //     title: (props) => {
      //       return props.schildname;
      //     },
      //     popup: (obj) => {
      //       const props = obj.props;
      //       const streettype = obj.streettype;
      //       const url = `syncdata/dwista/${props.url}`;
      //       const html = `
      //         <div class="displayflex">
      //           <div class="${streettype} maxWidth50 textcenter widthFit fontweight600 marginbottom15" style="padding:1.5px 10px">
      //             ${props.street}
      //           </div>
      //           <div class="marginleft5 displayflex displayflexColumn">
      //             <b>${props.standort}</b>
      //             <span>Richtung ${props.fahrtrichtung}</span>
      //           </div>
      //         </div>
      //         <img style="width: 300px; cursor: pointer;" src="${url}?${Date.now()}" onclick="document.getElementById('dwistaPicture').src='${url}'; document.getElementById('modalDwista').style.display='block'; event.stopPropagation(); ">
      //       `;
      //       return html;
      //     },
      //     iconUrl: (props) => {
      //       const data = require(`../public/img/vue_svg/dwista.svg`);
      //       return { data, type: 'svg' };
      //     }
      //   }
      // },
      // {
      //   id: 5,
      //   name: 'Parkplätze und Rastanlagen',
      //   active: false,
      //   sidebarIcon: {
      //     img_on: 'parkplatz_on',
      //     img_off: 'parkplatz_off',
      //     type: 'svg'
      //   },
      //   icons: {
      //     src: 'syncdata/poiparkplatz.json',
      //     data: null,
      //     reload: false,
      //     markerCluster: { name: 'parkplatz_cluster', colorClass: 'colorDarkBlue' }, // 'greyMarkerCluster',
      //     title: (props) => props.title,
      //     popup: (obj) => {
      //       const props = obj.props;
      //       const streettype = obj.streettype;
      //       const html = `
      //       <div class="${streettype} maxWidth50 textcenter widthFit fontweight600 marginbottom15" style="padding:1.5px 10px">
      //         ${props.street}
      //       </div>
      //       <div class="marginbottom15 fontweight600">${props.type}</div>
      //       <div class="displayflex flexstart">
      //         <img class="svgIcon backgroundDarkBlue ${props.icon === 'tank_und_rast' || props.icon === 'tankstelle_on' ? 'borderRadiusLeft10' : 'borderRadius10'} padding5" src="img/vue_svg/parkplatz.svg" />
      //         ${props.icon === 'tank_und_rast' ? '<img class="svgIcon backgroundDarkBlue padding5" src="img/vue_svg/raststätte_wc.svg" /><img class="svgIcon backgroundDarkBlue padding5" src="img/vue_svg/tankstelle.svg" /><img class="svgIcon backgroundDarkBlue borderRadiusRight10 padding5" src="img/vue_svg/raststätte.svg" />' : ''}
      //         ${props.icon === 'tankstelle_on' ? '<img class="svgIcon backgroundDarkBlue borderRadiusRight10 padding5" src="img/vue_svg/tankstelle.svg" />' : ''}
      //       </div>
      //       `;
      //       return html;
      //     },
      //     iconUrl: (props) => {
      //       return {
      //         data: require(`../public/img/vue_svg/parkplatz_on.svg`),
      //         type: 'svg'
      //       };
      //     }
      //   }
      // },
      // {
      //   id: 6,
      //   name: 'Freie Parkplätze für LKW',
      //   active: false,
      //   listenansicht: {
      //     name: 'Freie Parkplätze für LKW',
      //     streets: []
      //   },
      //   sidebarIcon: {
      //     img_on: 'lkw_parken_on',
      //     img_off: 'lkw_parken_off',
      //     type: 'svg'
      //   },
      //   icons: {
      //     src: 'syncdata/poilkw.json',
      //     data: null,
      //     reload: true,
      //     markerCluster: { name: 'lkw_cluster', colorClass: 'colorDarkBlue' }, // 'greyMarkerCluster',
      //     title: (props) => props.title,
      //     popup: (obj) => {
      //       const props = obj.props;
      //       const streettype = obj.streettype;
      //       const html = `
      //       <div class="${streettype} maxWidth50 textcenter widthFit fontweight600 marginbottom15" style="padding:1.5px 10px">
      //         ${props.street}
      //       </div>
      //       <div class="fontweight600">${props.von}</div>
      //       <div class="marginbottom15 fontweight600">Richtung ${props.richtung}</div>
      //       <div class="displayflex flexbetween">
      //         <div class="colorDarkGrey marginright30 selfAlignCenter">Freie LKW-Stellplätze:</div>
      //         <div class="borderRadius30 ${props.spaces === 0 ? 'backgroundRed' : 'backgroundLightGreen'} fontweight600 displayflex flexcenter" style="width:30px;height:30px;">
      //           <div class="selfAlignCenter">${props.spaces}</div>
      //         </div>
      //       </div>
      //       <div class="displayflex colorDarkGrey">Live</div>
      //       <div class="displayflex colorDarkGrey">${props.time} Uhr</div>
      //       `;
      //       return html;
      //     },
      //     iconUrl: (props) => {
      //       return {
      //         data: require(`../public/img/vue_svg/lkw_parken_on.svg`),
      //         type: 'svg'
      //       };
      //     }
      //   }
      // },
      {
        id: 7,
        name: 'E-Tankstellen',
        active: false,
        sidebarIcon: {
          img_on: 'e_tankstelle_on',
          img_off: 'e_tankstelle_off',
          type: 'svg',
        },
        icons: {
          src: 'syncdata/poitankstellen.json',
          data: null,
          reload: false,
          filter: {
            Betreiber_: null,
            Anzahl_Ladepunkte_: null,
            Art_des_Ladepunktes_: null,
            Nennleistung_Ladepunkt_1_: null,
          },
          markerCluster: { name: 'e_tankstelle_cluster', colorClass: 'colorLightGreen' }, // 'greyMarkerCluster',
          title: (props) => props['fÃ¼r_die_Ãœberschrift_'],
          popup: (obj) => {
            const props = obj.props;
            const streettype = obj.streettype;
            let html = '';
            if (props.roadnumber) {
              html += `<div class="${streettype} maxWidth50 textcenter widthFit fontweight600 marginbottom15" style="padding:1.5px 10px">
                        ${props.roadnumber}
                      </div>`;
            }
            html += `${props.Standort_}<br><br>`;
            html += `Verbund: <strong>${props.Betreiber_}</strong><br>`;
            html += `Anzahl Ladepunkte: <strong>${props.Anzahl_Ladepunkte_}</strong><br>`;

            const ladeStecker = {};
            for (let i = 1; i <= Number(props.Anzahl_Ladepunkte_); i++) {
              ladeStecker[props[`AC_Steckdose_Typ_2__${i}_`]] = props[`Nennleistung_Ladepunkt_${i}_`];
            }

            const strings = [];
            for (const ladeSteckerTyp in ladeStecker) {
              strings.push(`${ladeSteckerTyp} ${ladeStecker[ladeSteckerTyp]}`);
            }
            html += `Ladestecker: <strong>${strings.join(', ')}</strong>`;

            return html;
          },
          // Rückgabe des SVG XMLs für das Icon
          iconUrl: (props) => {
            // check ob ETankstelle in der Nähe der Autobahn
            return {
              data: props.roadnumber
                ? require(`../public/img/vue_svg/e_tankstelle_on.svg`)
                : require(`../public/img/vue_svg/e_tankstelle_on_keineAutobahn.svg`),
              type: 'svg',
            };
          },
        },
      },
      {
        id: 8,
        name: 'Verkehrsprognose',
        active: false,
        wms: {
          src: 'cgi-bin/mapserv?map=map/asda.map&',
          layerName: 'divaprognoseline',
          format: 'image/png',
        },
        icons: {
          src: 'syncdata/poidivaprognose.json',
          data: null,
          reload: true,
          markerCluster: {
            name: 'stau_cluster',
            colorClass: 'colorRed',
          }, // 'redMarkerCluster',
          title: (props) => props.title,
          popup: (obj) => {
            const props = obj.props;
            const streettype = obj.streettype;
            const html = `
              <div class="colorYellow marginbottom15">Trend</div>
              <div class="${streettype} maxWidth50 textcenter widthFit fontweight600 marginbottom15" style="padding:1.5px 10px">
                ${props.street}
              </div>
              <div class="marginbottom15">${props.von} →</br> ${props.bis}</div>
              ${props.staulaenge
                ? `<div class="fontweight600 widthFit marginbottom15">
                  ${props.staulaenge} km ${props.type === 'STATIONARY_TRAFFIC' ? 'Stau' : 'zähfließender Verkehr'}
                </div>`
                : ''
              }
              <div class="displayflex">
                <div class="backgroundYellow borderRadius30 fontweight600 widthFit marginbottom15" style="padding:1.5px 10px;">
                  + ${props.reisezeitverlust} Min 
                </div>
              </div>
              <small>Stand: ${props.stand}</small>
            `;
            return html;
          },
          iconUrl: (props) => {
            let data = eventmap[props.type]
              ? require(`../public/img/vue_svg/${eventmap[props.type]}.svg`)
              : require(`../public/img/vue_svg/gefahr.svg`);
            if (props.reisezeitverlust) {
              data += `
                <div 
                  style="height:18px;position:absolute;top: -9px;right:0;padding: 0 10px;background-color: #EFD53C; white-space:nowrap;transform: translate(75%,0); box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px;" 
                  class="textcenter backgroundWhite fontweight600 borderRadius30"
                >
                  + ${props.reisezeitverlust} min.
                </div>
                `;
            }
            return { data, type: 'svg' };
          },
        },
      },
    ],
    routen: [],
    kartenansicht: null,
    editStrecke: null,
    pushPossible: false,
    pushID: null,
    SWReg: null,
    isSubscribed: null,
  },
  mutations: {
    // ###############################
    // MAP
    // ###############################
    setKartenMode: (state, mode) => {
      state.kartenmode = mode;
      if (state.device === 'XS') {
        state.smallSidebarActive = false;
      }
    },
    setLayerActive: (state, obj) => {
      const layer = state.layers.find((layer) => layer.id === obj.layerId);
      layer.active = obj.active;
    },
    toggleLayerActive: (state, layerId) => {
      /* Show or hide the features in the layer */
      const layer = state.layers.find((layer) => layer.id === layerId);
      layer.active = !layer.active;
    },
    setJumpTo: (state, geometryArray) => {
      state.jumpTo = geometryArray;
    },

    // ###############################
    // Navigation
    // ###############################
    setSmallSidebar: (state, value) => {
      state.smallSidebarActive = value;
    },
    toggleSidebar: (state) => {
      state.sidebarActive = !state.sidebarActive;
    },
    minimizeSidebar: (state) => {
      state.sidebarActive = false;
    },
    setExtendedSidebarActiveFalse: (state) => {
      state.ExtendedSidebarActive = false;
    },
    setExtendedSidebarActive: (state) => {
      state.sidebarActive = false;
      state.ExtendedSidebarActive = true;
    },
    setExtendedSidebar: (state, name) => {
      state.ExtendedSidebarActiveLayer = name;
    },
    setActiveProfilOption: (state, setTo) => {
      state.activeProfilOption = setTo;
    },

    setFirstVisit: (state, setTo) => {
      state.firstVisit = setTo;
      localStorage.setItem('firstVisit', setTo);
    },

    // ###############################
    // Helper
    // ###############################
    setDevice: (state) => {
      state.width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

      const device = state.width >= 1200 ? 'L' : state.width >= 992 ? 'M' : state.width >= 769 ? 'S' : 'XS';
      state.device = device;
    },
    setIsSubscribed: (state, setTo) => {
      if (setTo) {
        localStorage.setItem('isSubscribed', setTo);
      } else {
        localStorage.removeItem('isSubscribed');
      }
      state.isSubscribed = setTo;
    },
    setPushNotifierSubscribed: (state, setTo) => {
      state.pushNotifierSubscribed = setTo;
    },

    // ###############################
    // Layer
    // ###############################
    setLayerIconsData: (state, obj) => {
      state.layers.forEach((layer) => {
        if (layer.id !== obj.id) return;
        layer.icons.data = obj.data;
      });
    },

    // { layerID, filterKey, value }
    setLayerFilter: (state, obj) => {
      state.layers.forEach((layer) => {
        if (layer.id !== obj.layerID) return;
        layer.icons.filter[obj.filterKey] = obj.value;
      });
      state.reloadLayer = true;
    },

    // {layerID}
    resetLayerFilter: (state, obj) => {
      const layer = state.layers.find((layer) => layer.id === obj.layerID);
      for (const filterKey of Object.keys(layer.icons.filter)) {
        layer.icons.filter[filterKey] = null;
      }
      state.reloadLayer = true;
    },

    setReloadLayer: (state, value) => {
      state.reloadLayer = value;
    },

    // ###############################
    // Listenansicht
    // ###############################
    setActiveListenansichtOption: (state, activeListenansichtOption) => {
      state.activeListenansichtOption = activeListenansichtOption;
    },
    setListenAnsichtStreets: (state) => {
      state.layers.forEach((layer) => {
        if (!layer.listenansicht) return;
        layer.icons.data.features.forEach((feature) => {
          if (!state.streetObjListenansicht[layer.listenansicht.name])
            state.streetObjListenansicht[layer.listenansicht.name] = [];
          if (state.streetObjListenansicht[layer.listenansicht.name].includes(feature.properties.street)) return;
          layer.listenansicht.streets.push({
            street: feature.properties.street,
            visibility: true,
          });
          state.streetObjListenansicht[layer.listenansicht.name].push(feature.properties.street);
        });
      });
    },
    toggleListenansichtVisibility: (state, streetLayername) => {
      state.layers.forEach((layer) => {
        if (!layer.listenansicht) return;
        if (layer.listenansicht.name !== streetLayername.layername) return;
        layer.listenansicht.streets.forEach((streetObj) => {
          if (streetObj.street !== streetLayername.street) return;
          if (typeof streetObj.visibility === 'undefined') streetObj.visibility = true;
          streetObj.visibility = !streetObj.visibility;
        });
      });
    },
    setAllListenansichtItems: (state, obj) => {
      state.layers.forEach((layer) => {
        if (!layer.listenansicht) return;
        if (layer.listenansicht.name !== obj.activeListenansichtOption) return;
        layer.listenansicht.streets.forEach((streetObj) => {
          streetObj.visibility = obj.setTo;
        });
      });
    },

    // ###############################
    // Personalisierung
    // ###############################
    // Routen
    setRouteLayer: (state, routeLayer) => {
      state.routeLayer = routeLayer;
    },
    setAllRoutenLayerVisible: (state, setTo) => {
      for (const route of state.routen) {
        route.layerVisible = setTo;
      }
    },

    // Push
    setPushID: (state, pushID) => {
      state.pushID = pushID;
      localStorage.setItem('pushID', pushID);
    },
    deletePushID: (state) => {
      state.pushID = null;
      localStorage.removeItem('pushID');
    },
    setSWReg: (state, SWReg) => {
      state.SWReg = SWReg;
    },
  },
  actions: {
    // ####################
    // Store initialisieren
    // ####################
    initialiseStore: ({ dispatch, state, commit }) => {
      commit('setDevice');
      // Seitenleiste ausklappen wenn es keine Mobilgerät Größe hat
      state.sidebarActive = state.device !== 'XS';
      // Routen initialisieren
      if (localStorage.getItem('routen') && localStorage.getItem('routen') !== 'null') {
        state.routen = JSON.parse(localStorage.getItem('routen'));
        if (state.routen[0].coordinates.type !== 'FeatureCollection') localStorage.clear();
      }

      // Kartenansicht initialisieren
      if (localStorage.getItem('kartenansicht') && localStorage.getItem('kartenansicht') !== 'null') {
        state.kartenansicht = JSON.parse(localStorage.getItem('kartenansicht'));
        // Layer so setzen wie gespeichert => Bounds werden in der Map Component gesetzt sobald verfügbar.
        state.layers.forEach((layer) => {
          layer.active = state.kartenansicht.currentLayer[layer.id];
        });
      }

      if (localStorage.getItem('pushID')) state.pushID = localStorage.getItem('pushID');

      // Check der Push Möglichkeiten im Browser falls keine Vorhanden
      if (isPushPossible(state)) {
        state.pushPossible = true;
      } else if (state.pushID) {
        commit('setPushNotifierSubscribed', true);
        state.isSubscribed = !!localStorage.getItem('isSubscribed');
      }

      dispatch('getSWReg');
      if (localStorage.getItem('PIN')) state.userPin = localStorage.getItem('PIN');
      // Check nach dem UserToken => angemeldet ja /nein
      if (localStorage.getItem('token')) state.userToken = localStorage.getItem('token');
      // Check nach dem DataTimestamp => Letzter Datenstand auf dem Server Kontrolle beim Laden der Webseite
      if (localStorage.getItem('dataTimestamp')) {
        state.dataTimestamp = localStorage.getItem('dataTimestamp');
      }

      // Check der Daten mit dem Server Wenn Pin Token und Timestamp vorhanden sind
      if (state.userPin && state.userToken && state.dataTimestamp) {
        dispatch('checkServerData');
        dispatch('setCheckServerDataInterval');
      }
    },

    // ####################
    // Kartenansicht
    // ####################
    saveKartenansicht: ({ state, dispatch }, kartenansichtObj) => {
      state.kartenansicht = kartenansichtObj;
      if (state.userToken) {
        dispatch('updateServerData', { parameter: 'create', target: 'kartenansicht', data: kartenansichtObj });
      } else {
        dispatch('saveKartenansichtLocalStorage');
      }
    },
    deleteKartenansicht: ({ state, dispatch }) => {
      state.kartenansicht = null;
      if (state.userToken) {
        dispatch('updateServerData', { parameter: 'remove', target: 'kartenansicht', data: null });
      } else {
        dispatch('removeKartenansichtLocalStorage');
      }
    },

    saveKartenansichtLocalStorage: ({ state, dispatch }) => {
      localStorage.setItem('kartenansicht', JSON.stringify(state.kartenansicht));
      dispatch('sendNotificationSuccess', 'Kartenansicht erfolgreich gespeichert');
    },

    removeKartenansichtLocalStorage: ({ state, dispatch }) => {
      localStorage.removeItem('kartenansicht');
      dispatch('sendNotificationSuccess', 'Kartenansicht erfolgreich gelöscht');
    },
    // ########################
    // Route
    // ###########################
    saveNeueRoute: ({ state, dispatch }, routeObj) => {
      state.routen.push(routeObj);
      dispatch('saveAlleRouten', { parameter: 'create', target: 'route', data: routeObj });
    },
    // Kopie des Objekts zum bearbeiten im BearbeitungsFenster
    setEditRoute: ({ state, dispatch }, route) => {
      state.editStrecke = JSON.parse(JSON.stringify(route));
    },
    deleteRoute: ({ state, dispatch }, routeInput) => {
      state.routen = state.routen.filter((route) => route.id !== routeInput.id);
      dispatch('saveAlleRouten', { parameter: 'remove', target: 'route', data: routeInput.id });
    },
    saveEditRoute: ({ state, dispatch }, routeInput) => {
      state.routen.forEach((route) => {
        if (route.id !== routeInput.id) return;
        route = Object.assign(route, routeInput);
        dispatch('saveAlleRouten', {
          parameter: 'update',
          target: 'route',
          data: {
            id: routeInput.id,
            updateData: {
              coordinates: routeInput.coordinates,
              start: routeInput.start,
              ziel: routeInput.ziel,
              titel: routeInput.titel,
            },
          },
        });
      });
    },
    saveRoutenLocalStorage: ({ state, dispatch }) => {
      localStorage.setItem('routen', JSON.stringify(state.routen));
      dispatch('sendNotificationSuccess', 'Routen erfolgreich gespeichert');
    },

    // Synchronisieren der Daten für den PushService
    saveAlleRouten: ({ state, dispatch }, objForUpdateServerData) => {
      const onSuccess = (response) => {
        if (state.userToken && objForUpdateServerData) {
          dispatch('updateServerData', objForUpdateServerData);
        } else {
          dispatch('saveRoutenLocalStorage');
        }
      };
      if (localStorage.getItem('pushID')) {
        dispatch('fetchToServer', {
          subURL: 'sendRouten',
          method: 'POST',
          body: {
            routen: state.routen,
            pushID: localStorage.getItem('pushID'),
          },
          onSuccess,
        });
      } else {
        onSuccess();
      }
    },
    // Synchronisieren der Daten im Front end mit dem BackEnd wenn ein Service vorhanden ist
    updateServerData: ({ dispatch, state }, payload) => {
      const onSuccess = (response) => {
        if (response.success) {
          if (payload.target === 'kartenansicht') {
            if (payload.parameter === 'remove') dispatch('removeKartenansichtLocalStorage');
            else if (payload.parameter === 'create') dispatch('saveKartenansichtLocalStorage');
          } else if (payload.target === 'route') dispatch('saveRoutenLocalStorage');
          state.dataTimestamp = response.success.timestamp;
          localStorage.setItem('dataTimestamp', response.success.timestamp);
        } else {
          dispatch('sendGenericError');
        }
      };
      dispatch('fetchToServer', {
        subURL: 'updateServerData',
        method: 'POST',
        body: {
          userPin: state.userPin,
          userToken: state.userToken,
          payload,
        },
        onSuccess,
      });
    },

    setCheckServerDataInterval: ({ dispatch, state }, deactivate) => {
      if (deactivate) {
        clearInterval(state.checkServerDataInterval);
      } else {
        state.checkServerDataInterval = setInterval(() => {
          dispatch('checkServerData');
        }, 30 * 1000);
      }
    },

    checkServerData: ({ dispatch, state }) => {
      const onSuccess = (response) => {
        if (response.success) {
          if (response.success.isSame) {
          } else {
            // Speichern der Routen & Kartenansicht
            const json = JSON.parse(response.success.data);
            state.routen = json.routen;
            // Speichern der Route unter der PushID falls vorhanden zum senden von PushBenachrichtigungen
            dispatch('saveAlleRouten');
            state.kartenansicht = json.kartenansicht;
            localStorage.setItem('kartenansicht', JSON.stringify(state.kartenansicht));
            // Speichern des DataTimestamps
            localStorage.setItem('dataTimestamp', response.success.timestamp);
            state.dataTimestamp = response.success.timestamp;
            // Meldung für den User
            dispatch('sendNotificationSuccess', 'Daten erfolgreich aktualisiert');
          }
        } else {
          dispatch('sendGenericError');
        }
      };

      dispatch('fetchToServer', {
        subURL: 'checkServerData',
        method: 'POST',
        body: {
          userPin: state.userPin,
          userToken: state.userToken,
          dataTimestamp: state.dataTimestamp,
        },
        onSuccess,
      });
    },

    fetchToServer: ({ state, dispatch }, options) => {
      state.isLoading = true;
      fetch(state.URL + 'api/' + options.subURL, {
        method: options.method,
        body: JSON.stringify(options.body),
        headers: { 'content-type': 'application/json' },
      })
        .then((response) =>
          response.json().then((data) => {
            state.isLoading = false;
            options.onSuccess(data);
          })
        )
        .catch((error) => {
          state.isLoading = false;
          if (options.onFailure) options.onFailure(error);
          else {
            dispatch('sendGenericError', error);
          }
        });
    },

    // ###########################
    // Feedback Nachrichten für den User
    // ###########################
    sendNotificationSuccess: ({ dispatch }, payload) => {
      dispatch('sendNotification', { text: payload, type: 'success' });
    },
    sendNotificationError: ({ dispatch }, payload) => {
      dispatch('sendNotification', { text: payload, type: 'error' });
    },

    sendNotification: ({ state }, payload) => {
      vue.$notify({
        group: 'notification',
        text: payload.text,
        type: payload.type,
        duration: 5000,
      });
    },

    // ###########################
    // Daten in DB speichern zum abruf auf anderen Geräten
    // ###########################
    serviceErstellen: ({ state, dispatch }, payload) => {
      // routen kartenansicht speichern mit dem passwort wo id = pin
      payload.data = {
        kartenansicht: state.kartenansicht,
        routen: state.routen,
      };
      dispatch('fetchToServer', {
        subURL: 'serviceErstellen',
        method: 'POST',
        body: payload,
        onSuccess: (data) => {
          if (data.success) {
            // Speichern des User Tokens
            localStorage.setItem('token', data.success.token);
            state.userToken = data.success.token;
            // Setzen des Timestamps der Daten auf dem Server zur Kontrolle
            localStorage.setItem('dataTimestamp', data.success.timestamp);
            state.dataTimestamp = data.success.timestamp;
            // Zurück zum Hauptmenü
            state.activeProfilOption = null;
            // Meldung für den User
            dispatch('sendNotificationSuccess', 'Service erfolgreich erstellt');
            dispatch('setCheckServerDataInterval');
          } else if (data.error === 'Falsches Passwort / Pin') {
            dispatch('sendNotificationError', data.error);
          } else dispatch('sendGenericError');
        },
      });
    },

    serviceLaden: ({ state, dispatch }, payload) => {
      // service laden mit pin und passwort
      dispatch('fetchToServer', {
        subURL: 'serviceLaden',
        method: 'POST',
        body: payload,
        onSuccess: (data) => {
          if (data.success) {
            // Speichern der Routen & Kartenansicht
            const json = JSON.parse(data.success.data);
            state.routen = json.routen;
            // Speichern der Route unter der PushID falls vorhanden zum senden von PushBenachrichtigungen
            dispatch('saveAlleRouten');
            state.kartenansicht = json.kartenansicht;
            localStorage.setItem('kartenansicht', JSON.stringify(state.kartenansicht));
            // Zurück zum Hauptmenü
            state.activeProfilOption = null;
            // Speichern der Pin
            localStorage.setItem('PIN', payload.pin);
            state.userPin = payload.pin;
            // Speichern des User Tokens
            localStorage.setItem('token', data.success.token);
            state.userToken = data.success.token;
            // Speichern des DataTimestamps
            localStorage.setItem('dataTimestamp', data.success.timestamp);
            state.dataTimestamp = data.success.timestamp;
            // Meldung für den User
            dispatch('sendNotificationSuccess', 'Service erfolgreich geladen');
            dispatch('setCheckServerDataInterval');
          } else if (data.error === 'pwpinfalse') {
            dispatch('sendNotificationError', 'Falscher Pin / Passwort');
          } else {
            dispatch('sendGenericError');
          }
        },
      });
    },

    serviceAbmelden: ({ state, dispatch, commit }) => {
      if (state.SWReg && state.isSubscribed) {
        dispatch('unsubscribeUser');
      } else if (state.pushNotifierSubscribed) {
        dispatch('logoutPushNotifier');
      }
      state.kartenansicht = null;
      state.routen = [];
      state.userPin = null;
      state.userToken = null;
      state.pushID = null;
      state.dataTimestamp = null;
      localStorage.clear();
      dispatch('sendNotificationSuccess', 'Erfolgreich ausgeloggt');
      commit('setFirstVisit', false);
      dispatch('setCheckServerDataInterval', true);
    },

    // ###########################
    // Push An / Aus
    unsubscribeUser: ({ state, dispatch, commit }) => {
      if (!state.SWReg) {
        dispatch('sendGenericError');
      } else {
        const obj = {};
        if (state.pushID) obj.id = state.pushID;
        state.SWReg.pushManager
          .getSubscription()
          .then((subscription) => {
            if (subscription) {
              obj.subscription = subscription;
              dispatch('fetchToServer', {
                subURL: 'unsubscribe',
                method: 'POST',
                body: obj,
                onSuccess: (json) => {
                  if (json.success) {
                    return subscription.unsubscribe();
                  } else {
                    dispatch('sendGenericError');
                  }
                },
              });
            }
          })
          .catch((error) => {
            dispatch('sendGenericError', error);
          })
          .then(() => {
            commit('deletePushID');
            state.isSubscribed = false;
            dispatch('sendNotificationSuccess', 'Benachrichtigungen erfolgreich abgemeldet');
          });
      }
    },

    loginPushNotifier: ({ state, commit, dispatch }, loginBody) => {
      dispatch('fetchToServer', {
        subURL: 'loginPushNotifier',
        method: 'POST',
        body: loginBody,
        onSuccess: (json) => {
          // Get returned ID => SaveID
          if (json.id) {
            commit('setPushNotifierSubscribed', true);
            commit('setPushID', json.id);
            commit('setIsSubscribed', true);
            dispatch('sendNotificationSuccess', 'Benachrichtigungen erfolgreich abonniert');
            dispatch('saveAlleRouten');
          } else if (json.error === 'Invalid username or password.') {
            dispatch('sendNotificationError', 'PushNotifier Benutzer oder Passwort ungültig');
          } else {
            dispatch('sendGenericError');
          }
        },
      });
    },

    setPushNotifierActiveTo: ({ state, commit, dispatch }, setTo) => {
      dispatch('fetchToServer', {
        subURL: 'setPushNotifierActiveTo',
        method: 'POST',
        body: { setTo, pushID: state.pushID },
        onSuccess: (json) => {
          // Get returned ID => SaveID
          if (json.success) {
            commit('setIsSubscribed', setTo);
            dispatch('sendNotificationSuccess', 'Benachrichtigungen ' + (setTo ? 'aktiviert' : 'deaktiviert'));
          } else {
            dispatch('sendGenericError');
          }
        },
      });
    },

    logoutPushNotifier: ({ state, commit, dispatch }) => {
      dispatch('fetchToServer', {
        subURL: 'logoutPushNotifier',
        method: 'POST',
        body: { pushID: state.pushID },
        onSuccess: (json) => {
          // Get returned ID => SaveID
          if (json.success) {
            commit('setIsSubscribed', false);
            commit('setPushNotifierSubscribed', false);

            commit('deletePushID');
            dispatch('sendNotificationSuccess', 'Benachrichtigungen erfolgreich abgemeldet');
          } else {
            dispatch('sendGenericError');
          }
        },
      });
    },

    subscribeUser: ({ state, commit, dispatch }) => {
      const applicationServerKey = urlB64ToUint8Array(state.applicationServerPublicKey);
      if (!state.SWReg) {
        // Versuch SWReg zu erneuern
        dispatch('getSWReg', () => {
          if (!state.SWReg) {
            // immer noch keine SWReg
            dispatch('sendNotificationError', 'Sie konnten für Benachrichtigungen nicht registriert werden');
          } else {
            // SWReg geupdatet
            dispatch('subscribeUser');
          }
        });
      } else {
        state.SWReg.pushManager
          .subscribe({
            userVisibleOnly: true,
            applicationServerKey: applicationServerKey,
          })
          .then((subscription) => {
            // Send subscription to application server
            const obj = { subscription };
            dispatch('fetchToServer', {
              subURL: 'subscribe',
              method: 'POST',
              body: obj,
              onSuccess: (json) => {
                // Get returned ID => SaveID
                state.isSubscribed = true;
                commit('setPushID', json.id);
                navigator.serviceWorker.controller.postMessage(JSON.stringify(json));
                dispatch('sendNotificationSuccess', 'Benachrichtigungen erfolgreich abonniert');
                dispatch('saveAlleRouten');
              },
              onError: (e) => {
                dispatch(
                  'sendNotificationError',
                  'Das Abonnemnent für die Benachrichtigungen konnte nicht gespeichert werden'
                );
              },
            });
          })
          .catch((e) => {
            dispatch('sendNotificationError', 'Benachrichtigungen konnten nicht abonniert werden');
          });
      }
      function urlB64ToUint8Array(base64String) {
        const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
        const base64 = (base64String + padding).replace(/\-/g, '+').replace(/_/g, '/');

        const rawData = window.atob(base64);
        const outputArray = new Uint8Array(rawData.length);

        for (let i = 0; i < rawData.length; ++i) {
          outputArray[i] = rawData.charCodeAt(i);
        }
        return outputArray;
      }
    },

    sendGenericError: ({ state, commit, dispatch }, error) => {
      // if (error) console.log(error)
      dispatch('sendNotificationError', 'Etwas ist schiefgelaufen. Bitte versuchen Sie es später erneut');
    },

    loadNewsticker: async ({ state }) => {
      const response = await fetch('syncdata/newsticker.json', {
        credentials: 'same-origin',
      });
      const data = await response.json();
      const now = new Date().getTime();
      state.newstickerMeldungen = data.filter(
        (newstickerMeldung) =>
          new Date(newstickerMeldung.timestamp_start).getTime() < now &&
          new Date(newstickerMeldung.timestamp_end).getTime() > now
      );
    },

    getPin: ({ dispatch, state }) => {
      dispatch('fetchToServer', {
        subURL: 'getPIN',
        method: 'GET',
        onSuccess: (data) => {
          if (data.id) {
            localStorage.setItem('PIN', data.id);
            state.userPin = data.id;
          }
        },
        onFailure: (e) => {
          dispatch(
            'sendNotificationError',
            'Ein Fehler beim Laden des Services ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.'
          );
        },
      });
    },

    getSWReg: ({ state }, callback) => {
      // Service Worker abfragen
      if (!navigator.serviceWorker) {
        return;
      }
      navigator.serviceWorker
        .getRegistrations()
        .then((registrations) => {
          if (registrations[0]) {
            registrations[0].pushManager.getSubscription().then((subscription) => {
              // check subscription status
              state.isSubscribed = !(subscription === null);
            });
            state.SWReg = registrations[0];
          }
          if (callback) callback();
        })
        .catch((e) => { });
    },
  },
});
